import { axiosWithConfig } from '@assembly/config/axios'

export const getSkillsAssessment = (payload: any, page?: number, pageSize?: number) => {
    const params = new URLSearchParams()
    if (page !== undefined) {
        params.append('page', page.toString())
    }
    if (pageSize !== undefined) {
        params.append('page_size', pageSize.toString())
    }
    return axiosWithConfig.post(`/recruiting/skills-assessment/search?${params.toString()}`, payload)
}

export const createSkillAssessment = (payload: any) => {
    return axiosWithConfig.post(`/recruiting/skills-assessment`, payload)
}

export const updateSkillAssessment = (payload: any) => {
    return axiosWithConfig.put(`/recruiting/skills-assessment`, payload)
}

export const deleteSkillAssessment = (id: string) => {
    return axiosWithConfig.delete(`/recruiting/skills-assessment/${id}`)
}